/**
 * @file Automatically generated by barrelsby.
 */

export * from './address.component';
export * from './address.module';
